import axios from './../../function/axiosInstance'
import extract from './../../function/extract'

export const fetchFeedbacks = async (
  assignmentId: string,
  params?: { company_id?: string }
): Promise<ApiResponseV2<Feedbacks>> => {
  try {
    const response = await axios.get<Feedbacks>(
      `/assignments/${assignmentId}/feedback`,
      { params }
    )

    return extract.data(response)
  } catch (error) {
    return extract.error(error)
  }
}
